import { c as _c } from "react/compiler-runtime";
import { Link } from '@/components/links';
import RightArrow from '@/assets/icons/heroIcons/Chevron-right.svg';
import StarIcon from '@/assets/icons/heroIcons/Star.svg';
import GoogleLogo from '@/assets/logos/Google_Maps.svg';
import FacebookLogo from '@/assets/logos/Facebook.svg';
import MapyCzLogo from '@/assets/logos/Mapy_cz.svg';
import PetNejLogo from '@/assets/logos/5nej.svg';
import googlePlayLogo from '@/assets/logos/Google_Play.png';
import AtmoskopLogo from '@/assets/logos/Atmoskop.svg';
import { SectionHeadline } from '@/components/SectionHeadline';
import { Button } from '@/components/buttons';
import { LINKS } from '@/constants/links';
import { mergeClasses } from '@/utils/style';
import { useTranslation } from 'react-i18next';
import React, { ReactNode, Suspense, useRef } from 'react';
import Image from 'next/image';
import { Swiper, SwiperSlide } from 'swiper/react';
import { A11y, EffectCards, Navigation } from 'swiper/modules';
import { Swiper as SwiperType } from 'swiper';
import { Tooltip } from '@/components/Tooltip';
import IconInformationCircle from '@/assets/icons/heroIcons/InformationCircle.svg';
import 'swiper/css';
import 'swiper/css/effect-cards';
import 'swiper/css/navigation';
import { Testimonial } from '@/api/sanity/testimonials';
import Loader from '@/components/Loader';
import { useIsSelectedLanguage } from '@/hooks/useIsSelectedLanguage';
export enum Source {
  facebook = 'facebook',
  google = 'google',
  mapy = 'mapy',
  petNej = '5nej',
  googlePlay = 'googlePlay',
  atmoskop = 'atmoskop',
}
function getSourceLogo(type: string) {
  if (type === Source.facebook) {
    return <FacebookLogo />;
  }
  if (type === Source.mapy) {
    return <MapyCzLogo />;
  }
  if (type === Source.petNej) {
    return <PetNejLogo />;
  }
  if (type === Source.googlePlay) {
    return <Image src={googlePlayLogo} alt="Google Play" width={107} />;
  }
  if (type === Source.atmoskop) {
    return <AtmoskopLogo />;
  }
  return <GoogleLogo />;
}
function Arrow(t0) {
  const $ = _c(16);
  const {
    onClick,
    variant
  } = t0;
  const {
    t
  } = useTranslation("core");
  const t1 = variant === "prev" ? "right-[50%] lg:mr-[27rem] xl:mr-[32rem]" : "left-[50%] lg:ml-[27rem] xl:ml-[32rem]";
  let t2;
  if ($[0] !== t1) {
    t2 = mergeClasses("absolute top-1/2 z-20 hidden h-16 w-16 -translate-y-1/2 cursor-pointer place-content-center rounded-full bg-blue-500 text-white transition-colors hover:bg-blue-700 lg:block", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = variant === "prev" ? "testimonials.buttonPrev" : "testimonials.buttonNext";
  let t4;
  if ($[2] !== t || $[3] !== t3) {
    t4 = t(t3);
    $[2] = t;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t4) {
    t5 = <span className="sr-only">{t4}</span>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = variant === "prev" && "rotate-180";
  let t7;
  if ($[7] !== t6) {
    t7 = mergeClasses("mx-auto h-8 w-8", t6);
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t7) {
    t8 = <RightArrow className={t7} />;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== onClick || $[12] !== t2 || $[13] !== t5 || $[14] !== t8) {
    t9 = <button type="button" className={t2} onClick={onClick}>{t5}{t8}</button>;
    $[11] = onClick;
    $[12] = t2;
    $[13] = t5;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
}
function CardB2B(t0) {
  const $ = _c(21);
  const {
    name,
    job,
    text,
    link,
    logo
  } = t0;
  const {
    t
  } = useTranslation("core");
  let t1;
  if ($[0] !== job || $[1] !== link || $[2] !== logo || $[3] !== name || $[4] !== t) {
    t1 = logo && <div className="flex items-center justify-center"><Link aria-label={t("testimonials.accessibility.showSource")} to={link} testId="testimonial" analyticsParam="testimonial" target="_blank"><Image src={logo} alt={`${name} ${job}`} width={100} height={28} className="h-7 w-auto" /></Link></div>;
    $[0] = job;
    $[1] = link;
    $[2] = logo;
    $[3] = name;
    $[4] = t;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== text) {
    t2 = <p className="mt-8 line-clamp-14 overflow-hidden text-sm">{text}</p>;
    $[6] = text;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t1 || $[9] !== t2) {
    t3 = <div>{t1}{t2}</div>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== name) {
    t4 = <h3 className="text-center text-base font-semibold">{name}</h3>;
    $[11] = name;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== job) {
    t5 = <p className="text-center text-xs font-semibold">{job}</p>;
    $[13] = job;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t4 || $[16] !== t5) {
    t6 = <div>{t4}{t5}</div>;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t3 || $[19] !== t6) {
    t7 = <div className="px-4 py-8"><div className="mx-auto h-[31rem] w-full max-w-[23rem] rounded-3xl bg-white p-8 text-center shadow-lg"><div className="flex h-full flex-col justify-between gap-6">{t3}{t6}</div></div></div>;
    $[18] = t3;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
}
function Card(t0) {
  const $ = _c(21);
  const {
    name,
    text,
    link,
    source,
    ratingStars
  } = t0;
  const {
    t
  } = useTranslation("core");
  let t1;
  if ($[0] !== ratingStars) {
    t1 = Array(5).fill(null).map((_, index) => <StarIcon key={index} className={ratingStars && index < parseInt(ratingStars) ? "text-orange-500" : "text-light-gray-300"} />);
    $[0] = ratingStars;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const starElements = t1;
  let t2;
  if ($[2] !== name) {
    t2 = <h3 className="mb-2 text-xl font-semibold">{name}</h3>;
    $[2] = name;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== ratingStars || $[5] !== starElements || $[6] !== t) {
    t3 = ratingStars && ratingStars !== "hidden" && <div className="inline-block"><div className="flex items-center justify-items-center gap-1.5 rounded-full bg-blue-50 px-2 py-1.5">{starElements}<span className="ml-2.5 text-xs font-semibold">{ratingStars}{t("testimonials.sectionScore")}</span></div></div>;
    $[4] = ratingStars;
    $[5] = starElements;
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== text) {
    t4 = <p className="text-md mt-8 mb-6 line-clamp-8 overflow-hidden">{text}</p>;
    $[8] = text;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t2 || $[11] !== t3 || $[12] !== t4) {
    t5 = <div>{t2}{t3}{t4}</div>;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== link || $[15] !== source || $[16] !== t) {
    t6 = source && <div className="mx-auto inline-block"><Link aria-label={t("testimonials.accessibility.showSource")} to={link} testId="testimonial" analyticsParam="testimonial" target="_blank">{getSourceLogo(source)}</Link></div>;
    $[14] = link;
    $[15] = source;
    $[16] = t;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t5 || $[19] !== t6) {
    t7 = <div className="px-4 py-8"><div className="mx-auto h-[25rem] w-full max-w-[23rem] rounded-3xl bg-white p-8 text-center shadow-lg"><div className="flex h-full flex-col justify-between">{t5}{t6}</div></div></div>;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
}
interface TestimonialsProps {
  testimonials: Testimonial[];
  title?: string;
  buttons?: ReactNode;
  anchorKey?: string;
}
export function Testimonials({
  buttons,
  testimonials,
  title,
  anchorKey = 'core.testimonials.sectionTitle'
}: TestimonialsProps) {
  const {
    t
  } = useTranslation('core');
  const navigationPrevRef = useRef(null);
  const navigationNextRef = useRef(null);
  const swiperRef = useRef<SwiperType | null>(null);
  const isCsLanguage = useIsSelectedLanguage('cs');
  return <div>
			<Suspense fallback={<Loader />}>
				<div className="mb-2 flex items-center justify-center gap-4 lg:mb-8">
					<SectionHeadline className="flex items-center justify-center gap-4 md:flex md:gap-6" anchorKey={anchorKey}>
						<span className="max-w-[12rem] flex-1 sm:max-w-full">
							{title || t('testimonials.sectionTitle')}
						</span>
						<span className="shrink-0 text-sm font-normal">
							<Tooltip placement="top" tooltip={t('testimonials.sectionDisclaimer')}>
								<span className="text-light-gray-500 inline-block">
									<IconInformationCircle />
								</span>
							</Tooltip>
						</span>
					</SectionHeadline>
				</div>
				<div className="relative mx-auto w-full overflow-hidden md:overflow-visible lg:w-[60rem]">
					{testimonials?.length > 0 && <Swiper effect={'cards'} initialSlide={1} grabCursor navigation={{
          nextEl: navigationNextRef.current,
          prevEl: navigationPrevRef.current
        }} modules={[EffectCards, A11y, Navigation]} keyboard={{
          enabled: true
        }} cardsEffect={{
          rotate: false,
          slideShadows: false,
          perSlideOffset: 26
        }} onBeforeInit={swiper => {
          swiperRef.current = swiper;
        }}>
							{testimonials.map((testimonial, key) => {
            return <SwiperSlide key={key}>
										{testimonial.type === 'b2b' ? <CardB2B {...testimonial} /> : <Card {...testimonial} />}
									</SwiperSlide>;
          })}
						</Swiper>}
					<Arrow variant="prev" onClick={() => swiperRef.current?.slidePrev()} />
					<Arrow variant="next" onClick={() => swiperRef.current?.slideNext()} />
				</div>
				{(buttons || isCsLanguage) && <div className="mt-4 lg:mt-8">
						{buttons ?? <Button variant="secondary" testId="allTestimonials" analyticsParam="allTestimonials" to={LINKS().testimonial} size="lg" align="center">
								{t('testimonials.sectionButton')}
							</Button>}
					</div>}
			</Suspense>
		</div>;
}